import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import * as utils from './utils/util'
import { getToken, setToken, removeToken } from './utils/storage'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

// 全局注册工具函数
Vue.prototype.$utils = utils

// 全局注册存储工具
Vue.prototype.$storage = {
  getToken,
  setToken,
  removeToken
}

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')